// extracted by mini-css-extract-plugin
export default {"header_box":"index_header_box_kCU9r","header":"index_header_Z6k2A clearfix"};